import { render } from "./AddAnneeAcademiqueModal.vue?vue&type=template&id=02464228&ts=true"
import script from "./AddAnneeAcademiqueModal.vue?vue&type=script&lang=ts"
export * from "./AddAnneeAcademiqueModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__